import { actionTypes } from "../../../types";

const initialState = {
    loading: false,
    status: '',
    message: '',
    data: [],
}

export default (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_SUCCESS:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
                data: action?.payload?.response
            }
        case actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_FAILURE:
            return {
                ...state,
                loading: false,
                status: action?.payload?.status,
                message: action?.payload?.message,
            }
        case actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_RESET:
            return {
                ...state,
                status: '',
                message: ''
            }
        case actionTypes.OPT_CAMPAIGN_NOT_PUBLISHED_RESET_ALL:
            return initialState
        default:
            return state;
    }
};
